"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.TaskSchema = __1.BaseSchema.extend({
    type: zod_1.z.nativeEnum(__1.TaskType),
    storeId: zod_1.z.string(),
    version: zod_1.z.number(),
    status: zod_1.z.nativeEnum(__1.TaskStatus),
    additionalInformation: zod_1.z.record(zod_1.z.unknown()).optional(),
    /**
     * Attribute to indicate the task is related to the user or store activation flow.
     */
    category: zod_1.z.nativeEnum(__1.TaskCategory).optional(),
    completedAt: zod_1.z.coerce.date().optional(),
    requiredCompletedTasks: zod_1.z.array(zod_1.z.nativeEnum(__1.TaskType)).optional(),
    relatedResource: zod_1.z
        .object({
        resourceId: zod_1.z.string(),
        resourceType: zod_1.z.string(),
    })
        .optional(),
    /**
     * Attribute to indicate the task id visibility to the user.
     */
    visibility: zod_1.z.nativeEnum(__1.TaskVisibility).optional(),
});
//# sourceMappingURL=task.js.map